import { createContext, useContext } from 'react';

import { SearchResultCardView } from '../types/types';

export type VendorGirdCardsValues = {
  vendorOrQuizCardViews: SearchResultCardView[];
};

export const VendorGridCardsContext = createContext<VendorGirdCardsValues | undefined>(undefined);

/**
 * Provides the cards to use in the vendor grid: either vendor cards OR quiz cards
 */
export const useVendorGridCards = () => {
  const context = useContext(VendorGridCardsContext);
  if (context === undefined) {
    throw new Error('VendorGridCardsContext must be used within a VendorGridCardsProvider');
  }
  return context;
};
